import { render } from "./card6.vue?vue&type=template&id=13702863&scoped=true"
import script from "./card6.vue?vue&type=script&lang=js"
export * from "./card6.vue?vue&type=script&lang=js"

import "./card6.vue?vue&type=style&index=0&id=13702863&scoped=true&lang=css"
import "./card6.vue?vue&type=style&index=1&id=13702863&scoped=true&lang=css"

import exportComponent from "/Users/jiangxin/xhw/outer-h5-gwj-nft-website-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13702863"]])

export default __exports__